"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryCarousel = exports.HeroCarousel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_just_carousel_1 = require("@hotelplan/components.common.just-carousel");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.HeroCarousel = (0, styled_components_1.default)(components_common_just_carousel_1.JustCarousel)(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.hero.wrap), { '.image-media': theme.hero.wrap })));
exports.GalleryCarousel = (0, styled_components_1.default)(components_common_just_carousel_1.JustCarousel)((0, util_theme_sxc_1.sx2CssThemeFn)({
    height: ['190px', '520px'],
}));
//# sourceMappingURL=fdr-media-autoplay-gallery.styles.js.map